import { Injectable } from '@angular/core';
import { Events } from '../classes/events';
import { OutboundAircraftAddEvent } from '../classes/outbound-aircraft-add-event';
import { OutboundAircraftUpdateEvent } from '../classes/outbound-aircraft-update-event';
import { LoggerService } from './logger.service';
import { MapIconService } from './map-icon.service';
import { MapPopUpService } from './map-popup.service';
import { UtilitiesService } from './utilities.service';
declare let L;
// const diff = require("deep-object-diff").diff;

@Injectable({
  providedIn: 'root'
})
export class OutboundAircraftMarkersService {
  outboundMarkerLayerGroup: L.LayerGroup = new L.LayerGroup();
  currentAirplaneMarkersOnMap = {};
  updateCount = 0;
  addedCount = 0;
  removedCount = 0;

  constructor(
    private mapPopUpService: MapPopUpService,
    private mapIconService: MapIconService,
    private logger: LoggerService,
    private utilityService: UtilitiesService
  ) { }


  processOutboundMarkers(data: Events): L.LayerGroup {
    this.updateCount = 0;
    this.addedCount = 0;
    this.removedCount = 0;
    let addEvents = data.outboundAircraftEvents.addEvents || [];
   // let deleteEvents = [506435];
    let deleteEvents = data.outboundAircraftEvents.deleteEvents || [];
    let updateEvents = data.outboundAircraftEvents.updateEvents || [];

    if(addEvents.length){
      this.addOutboundMarkers(addEvents);
    }

    if(updateEvents.length){
      this.updateOutboundMarkers(updateEvents);
    }

    if(deleteEvents.length){
      this.deleteOutboundMarkers(deleteEvents);
    }

   // this.getOutboundMarkersOnMap();
    this.logger.debug(`Outbound Markers: Added:${this.addedCount}|Updated:${this.updateCount}|Removed:${this.removedCount}`, 'markers');

    return this.outboundMarkerLayerGroup;
  }


  makeNewOutboundMarker(row: OutboundAircraftAddEvent, pos: L.LatLng): L.Marker {
        const marker = new L.Marker(pos, {
          icon: 		        this.mapIconService.makeOutboundAircraftIcon(row),
          markerType: 	    'unassigned',
          parkingPosition:  row.parkingPosition,
          ID: 			        row.id,
          flightNumber:     row.flightNumber,
          type: 		        'airplane',
          name: 		        row.tailNumber,
          status: 		      row.outboundAircraftStatus,
          dest: 		        row.destination,
          uniqueHash: 	    this.utilityService.guid()
      });
      marker.bindPopup(this.mapPopUpService.makeOutboundAircraftMarkerPopup(row));
      this.addedCount++;
      return marker;
  }


  addOutboundMarkers(addEvents: Array<OutboundAircraftAddEvent>){
    addEvents.forEach((row: OutboundAircraftAddEvent) => {
      const id = row.id;
      const pos = new L.LatLng(row.latitude, row.longitude);
      if (!this.currentAirplaneMarkersOnMap[id]) {
        this.currentAirplaneMarkersOnMap[id] = this.makeNewOutboundMarker(row, pos);
        this.outboundMarkerLayerGroup.addLayer(this.currentAirplaneMarkersOnMap[id]);
        this.logger.debug(`ADDED OUTBOUND MARKER: ${id}`, 'markers');
      } else {
        this.logger.debug(`SKIPPED ADDING OUTBOUND MARKER: ${id} - already exists on map`, 'markers');
      }
    });
  }


  updateOutboundMarkers(updateEvents: Array<OutboundAircraftUpdateEvent>) {
    updateEvents.forEach((row: OutboundAircraftUpdateEvent) => {
      const id = row.id;
      const pos = new L.LatLng(row.latitude, row.longitude);
      if(this.currentAirplaneMarkersOnMap[id]){
        this.currentAirplaneMarkersOnMap[id]
          .setLatLng(pos)
          .setPopupContent(this.mapPopUpService.makeOutboundAircraftMarkerPopup(row))
          .setIcon(this.mapIconService.makeOutboundAircraftIcon(row));
          this.logger.debug(`UPDATED OUTBOUND MARKER: ${id}`, 'markers');
        this.updateCount++;
      } else {
        this.logger.warn(`Cannot update marker ${id} - not found on map. Adding it instead.`);
        // Safety fallback: add the marker if it doesn't exist
        this.currentAirplaneMarkersOnMap[id] = this.makeNewOutboundMarker(row as any, pos);
        this.outboundMarkerLayerGroup.addLayer(this.currentAirplaneMarkersOnMap[id]);
        this.addedCount++;
      }
    });
    this.logger.debug("updateOutboundMarkers ran", 'markers');
  }


  deleteOutboundMarkers(deleteEvents: Array<number>) {
    deleteEvents.forEach((id) => {
      // Check if marker exists before attempting deletion
      if (this.currentAirplaneMarkersOnMap[id]) {
        this.logger.debug(`DELETING OUTBOUND MARKER: ${id}`, 'markers');
        try {
          this.outboundMarkerLayerGroup.removeLayer(this.currentAirplaneMarkersOnMap[id]);
          delete this.currentAirplaneMarkersOnMap[id];
          this.removedCount++;
        } catch(e) {
          this.logger.error(`Error removing marker ${id} from layer group:`, e);
          // Still delete from our tracking object even if layer removal fails
          delete this.currentAirplaneMarkersOnMap[id];
        }
      } else {
        this.logger.debug(`Skipped deleting marker ${id} - not found on map (may have been already removed)`, 'markers');
      }
    });
  }


  getOutboundMarkersOnMap(): Array<Object>{
    let outboundMarkersOnMap = [];
    let marker = {};
    this.outboundMarkerLayerGroup.eachLayer((layer) => {
      marker = {
        oam: layer['options']['ID'],
        pp: layer['options']['parkingPosition']
      }
      outboundMarkersOnMap.push(marker);
    });
    this.logger.debug('outboundMarkersOnMap:', outboundMarkersOnMap, 'markers');
    return outboundMarkersOnMap;
  }


  validateLatLngs(lat,lng): boolean{
    return this.utilityService.validateLatLngs(lat,lng);
  }

}
